module.exports = __webpack_public_path__ + "static/img_9495-51cb6be1402ace916b64ae365506ab07.webp";